import Api from '@/services/Api'

function getDeviceFingerprint() {
	const STORAGE_KEY = "device_fingerprint"
	let fp = localStorage.getItem(STORAGE_KEY)
	if (fp) return fp

	const parts = [
		navigator.userAgent || "",
		navigator.language || "",
		navigator.platform || "",
		screen.width + "x" + screen.height,
		screen.colorDepth || "",
		new Date().getTimezoneOffset(),
		navigator.hardwareConcurrency || "",
		navigator.maxTouchPoints || "",
	]

	let hash = 0
	const str = parts.join("|")
	for (let i = 0; i < str.length; i++) {
		const char = str.charCodeAt(i)
		hash = ((hash << 5) - hash) + char
		hash |= 0
	}

	fp = "fp_" + Math.abs(hash).toString(36) + "_" + str.length.toString(36)
	localStorage.setItem(STORAGE_KEY, fp)
	return fp
}

let cachedPublicIP = null
async function getPublicIP() {
	if (cachedPublicIP) return cachedPublicIP
	try {
		const res = await fetch("https://api.ipify.org?format=json")
		const data = await res.json()
		cachedPublicIP = data.ip
		return cachedPublicIP
	} catch {
		return null
	}
}

export default {
	async login (credentials) {
		const publicIP = await getPublicIP()
		return Api().post('signin', {
			...credentials,
			deviceFingerprint: getDeviceFingerprint(),
			publicIP: publicIP || undefined,
		})
	},
	async verifyMfa(form){
		const publicIP = await getPublicIP()
		return Api().post('signin/mfa/verify', {
			...form,
			deviceFingerprint: getDeviceFingerprint(),
			publicIP: publicIP || undefined,
		})
	},
	resendMfa(form){
		return Api().post('signin/mfa/resend', form)
	},
	validate(token){
		return Api().get('validate?t='+token)
	},
	setPassword(form){
		return Api().put('set-account', form)
	},
	resetPassword(form){
		return Api().put('reset-password', form)
	},
	requestPasswordResetCode(form){
		return Api().post('password-reset/request', form)
	},
	verifyPasswordResetCode(form){
		return Api().post('password-reset/verify', form)
	},
	confirmPasswordReset(form){
		return Api().post('password-reset/confirm', form)
	},
	getPasswordPolicy(){
		return Api().get('password-policy')
	},
	leaParametros(){
		return Api().get('leaParametros')
	},
	logout(){
		return Api().post('logout')
	},
	checkSession(){
		return Api().get('session/check')
	},
	getDeviceFingerprint,
	getPublicIP,
}